







































































































































































































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import { ValidationObserver } from "vee-validate";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import RequestPromises from "@/mixins/requestPromises";
import CurrenciesStore from "@/mixins/constants/currenciesStore";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ProvisionCategoryCodes } from "@/modules/web_hosting/data/enums";
import { ActionTypes } from "@/data/enums";

// Types
import {
  ITldForm,
  ITldDefaultSettings
} from "@/modules/web_hosting/models/domains";
import { IState } from "@/store";
import {
  IProvisionProvider,
  IProvisionConfiguration,
  IProvisionCategory
} from "@/models/provisioning";
import { IProduct, IProductPriceRecalculation } from "@/models/products";
import { IBrand } from "@/models/brands";

@Component({
  computed: {
    ...mapState({
      defaultTldSettingsScope(state: IState, getters) {
        return getters[
          `data/${DataModules.HOST_MODULE_TLDS}/defaultTldSettingsScope`
        ]();
      },
      defaultTldSettings(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: DataModules.HOST_MODULE_TLDS,
          scope: this.defaultTldSettingsScope
        });
      },

      configurationsScope(state: IState, getters) {
        return getters[`data/${DataModules.PROVISIONING_CONFIGURATIONS}/scope`];
      },
      configurations(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.PROVISIONING_CONFIGURATIONS,
          scope: this.configurationsScope
        });
      },

      brandId(state: IState) {
        return state.brand.id;
      },
      brandScope(state: IState, getters) {
        return getters[`data/${DataModules.BRANDS}/brandScope`](this.brandId);
      },
      brand(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: DataModules.BRANDS,
          scope: this.brandScope
        });
      }
    })
  },
  components: {
    "invoice-generation-control": () =>
      import("@/components/app/global/invoices/invoiceGenerationControl.vue"),
    "recurring-due-date-control": () =>
      import("@/components/app/global/invoices/recurringDueDateControl.vue"),
    "tld-pricing": () =>
      import("@/modules/web_hosting/components/domains/tldPricing.vue")
  }
})
export default class ManageTldModal extends Mixins(
  HasValidation,
  RequestPromises,
  CurrenciesStore
) {
  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    tld: HTMLFormElement;
  };

  // Map state

  public defaultTldSettingsScope!: Function;
  public defaultTldSettings!: ITldDefaultSettings;

  public configurationsScope!: string;
  public configurations!: IProvisionConfiguration[];

  public brandId!: IBrand["id"];
  public brand!: IBrand;
  public brandScope!: string;

  // Props

  @Prop({ default: null })
  public tld!: IProduct;

  @Prop({ required: true })
  public domainProviders!: IProvisionProvider[];

  @Prop({ required: true })
  public domainCategoryId!: IProvisionCategory["id"];

  // Variables

  public isLoading = false;
  public isReloading = false;
  public hasRequestError = false;
  public isProcessing = false;
  public hasPriceErrors = false;
  public isLoadingSettings = false;
  public isReloadingSettings = false;
  public hasSettingsError = false;

  public form: ITldForm = {
    tld: "",
    enabled: true,
    registrar: "",
    create_invoice_term: null,
    payment_days_term: null,
    late_renew_days: "",
    max_reg_period_years: "",
    redemption_period_days: "",
    prices: [],
    additional_currency_recalculation: 0
  };

  public initialForm = {} as ITldForm;
  public isNextStep = false;
  public adminTldsRouteName = "admin__hostControl::domainTlds";
  public recalculation = {} as IProductPriceRecalculation;

  // Lifecycle methods

  public async created() {
    if (!this.contentIsAvailable) return;

    this.isLoading = true;
    this.loadData();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: DataModules.HOST_MODULE_TLDS,
      scope: this.defaultTldSettingsScope,
      vm: this
    });

    this.$store.dispatch("data/binList", {
      storeModule: DataModules.PROVISIONING_CONFIGURATIONS,
      scope: this.configurationsScope,
      vm: this
    });
  }

  // Methods

  public async loadData(forceReload = false) {
    try {
      await Promise.all([
        this.getBrandDetails(this.isReloading || forceReload),
        this.getProvisionConfigurations(this.isReloading || forceReload),
        this.getCurrencies()
      ]);

      if (this.isUpdate) {
        this.$set(this.form, "tld", _.get(this.tld, "tld", ""));
        this.isNextStep = true;
        this.initialiseForm(forceReload);
      } else {
        this.tldFocus();
        this.updateRecalculation();
      }

      this.hasRequestError = false;
    } catch (error) {
      this.hasRequestError = true;
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getProvisionConfigurations(ignoreStored = false) {
    return this.$store.dispatch(
      `data/${DataModules.PROVISIONING_CONFIGURATIONS}/list`,
      {
        scope: this.configurationsScope,
        params: {
          limit: 0,
          "filter[category.code]": ProvisionCategoryCodes.DOMAINS,
          "filter[enabled]": true
        },
        vm: this,
        ignoreStored
      }
    );
  }

  public getBrandDetails(ignoreStored = false) {
    return this.$store.dispatch(`data/${DataModules.BRANDS}/get`, {
      id: this.brandId,
      scope: this.brandScope,
      ignoreStored,
      vm: this
    });
  }

  public async loadDefaultTldSettings() {
    try {
      await this.getTldDefaultSettings();
      this.initialiseForm(true);
      this.hasSettingsError = false;
    } catch (error) {
      this.hasSettingsError = true;
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoadingSettings = false;
      this.isReloadingSettings = false;
    }
  }

  public reloadSettingsData() {
    this.isReloadingSettings = true;
    this.loadDefaultTldSettings();
  }

  public getTldDefaultSettings() {
    return this.$store.dispatch(
      `data/${DataModules.HOST_MODULE_TLDS}/getTldDefaultSettings`,
      {
        tld: this.form.tld,
        scope: this.defaultTldSettingsScope,
        vm: this,
        ignoreStored: true
      }
    );
  }

  public initialiseForm(forceReload) {
    if (forceReload || !this.isUpdate) {
      _.forEach(
        this.defaultTldSettings,
        (defaultTldSettingValue, defaultTldSettingKey) => {
          if (!_.isNull(defaultTldSettingValue))
            this.$set(this.form, defaultTldSettingKey, defaultTldSettingValue);
        }
      );
    } else {
      this.form = _.merge(
        this.form,
        _.pick(this.tld, [
          "tld",
          "enabled",
          "registrar",
          "create_invoice_term",
          "late_renew_days",
          "max_reg_period_years",
          "payment_days_term",
          "redemption_period_days",
          "additional_currency_recalculation"
        ])
      );

      this.$set(
        this.form,
        "prices",
        _.map(
          _.filter(this.tld.prices, ["pricelist_id", this.brand.pricelist_id]),
          tldPrice =>
            _.pick(tldPrice, [
              "billing_cycle_months",
              "price",
              "pricelist_id",
              "currency_id"
            ])
        )
      );
    }

    this.updateRecalculation();

    this.initialForm = _.cloneDeep(this.form);
  }

  public updateRecalculation() {
    this.recalculation = _.find(
      this.multicurrencyOptions,
      option =>
        option.value ===
        _.get(this.form, "additional_currency_recalculation", 0)
    ) as IProductPriceRecalculation;
  }

  public changeRecalculation(newRecalculation) {
    _.set(
      this.form,
      "additional_currency_recalculation",
      newRecalculation ? newRecalculation.value : 0
    );

    if (!newRecalculation) {
      this.recalculation = this.multicurrencyOptions[0];
    }
  }

  public changeTld() {
    this.isNextStep = false;
    this.$refs.tld.focus();
  }

  public async validateBeforeSubmit() {
    if (!this.canManageTld) return;

    try {
      // Creating new - first step
      if (!this.isNextStep) {
        this.$set(this, "isNextStep", true);
        this.isLoadingSettings = true;
        this.loadDefaultTldSettings();
        return;
      }

      // Creating new - second step
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }

      this.isProcessing = true;

      this.isUpdate ? await this.updateTld() : await this.createTld();

      if (this.$route.name !== this.adminTldsRouteName) {
        this.$router.push({
          name: this.adminTldsRouteName
        });
      }

      this.$store.dispatch("toast/show", {
        message: this.$t(
          "_modules.web_hosting.domains.tld_successfully_created"
        )
      });

      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public createTld() {
    return this.$store.dispatch(`data/${DataModules.HOST_MODULE_TLDS}/create`, {
      data: this.formValues
    });
  }

  public updateTld() {
    return this.$store.dispatch(`data/${DataModules.HOST_MODULE_TLDS}/update`, {
      id: this.tld.id,
      data: this.formValues
    });
  }

  public getProviderLogoUrl(provider) {
    return provider.logo_url;
  }

  public openCreateConfigurationModal() {
    this.$store.dispatch(
      `data/${DataModules.PROVISIONING_CONFIGURATIONS}/openManageProviderConfigurationModal`,
      {
        props: {
          categoryId: this.domainCategoryId,
          actionType: ActionTypes.CREATE
        },
        events: {
          success: () => {
            this.loadData(true);
          }
        }
      }
    );
  }

  public tldFocus() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.$refs.tld?.focus();
      });
    }, 50);
  }

  // Computed

  public get isUpdate() {
    return !_.isNull(this.tld);
  }

  public get canShowNextStepFields() {
    return (
      this.isNextStep &&
      !this.isLoadingSettings &&
      !this.isReloadingSettings &&
      !this.hasSettingsError
    );
  }

  public get mainButtonPath() {
    if (!this.isNextStep) return "_action.next";

    return this.isUpdate ? "_action.update" : "_action.create";
  }

  public get canManageTld() {
    return this.isUpdate
      ? this.$userCan("web_hosting::update_tld_product")
      : this.$userCan("web_hosting::create_tld_product");
  }

  public get formIsValid() {
    return (
      this.contentIsAvailable &&
      this.canManageTld &&
      !this.isProcessing &&
      !this.hasErrors &&
      !this.hasSettingsError &&
      !!this.form.tld.length &&
      !this.hasPriceErrors
    );
  }

  public get fieldsAreDisabled() {
    return this.isProcessing || !this.canManageTld;
  }

  public get formValues() {
    return _.omitBy(
      this.form,
      formValue =>
        formValue === "" || (_.isArray(formValue) && formValue.length === 0)
    );
  }

  public get availableProviders() {
    return _.filter(this.domainProviders, domainProvider => {
      return _.some(this.configurations, ["provider_id", domainProvider.id]);
    });
  }

  public get multicurrencyOptions() {
    return [
      {
        leftLabel: this.$t("_.omit_product"),
        desc: this.$t("_sentence.omit_product_desc"),
        value: 0
      },
      {
        leftLabel: this.$t("_.make_available"),
        desc: this.$t("_sentence.make_available_desc", {
          currency: this.getCurrencyCode(this.brand.currency_id)
        }),
        value: 1
      },
      {
        leftLabel: this.$t("_.inherit_brand_default_value", {
          value: this.$t("_.omit_product")
        }),
        value: 2
      }
    ] as IProductPriceRecalculation[];
  }

  public get createInvoiceTermBV() {
    return _.get(this.brand, "create_invoice_term");
  }

  public get paymentDaysTermBV() {
    return _.get(this.brand, "payment_days_term");
  }

  // Guarding

  public get canManagePrices() {
    const managePricesFunctionalities = [
      "create_pricelist_product_prices",
      "delete_pricelist_product_prices",
      "sync_pricelist_product_prices",
      "update_product"
    ];
    return this.$userCan(...managePricesFunctionalities);
  }

  public guardFunctionalities = [
    "web_hosting::get_tld_product_default_settings",
    "list_provision_configurations"
  ];

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
